import { defineComponent as _defineComponent } from 'vue';
import { BForm, BFormInput, BModal } from "bootstrap-vue";
import { ref } from "vue";
import { updateWorkflow } from "@/components/Workflow/workflows.services";
import { Toast } from "@/composables/toast";
import localize from "@/utils/localization";
import Heading from "@/components/Common/Heading.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowRename',
    props: {
        id: null,
        name: null,
        show: { type: Boolean }
    },
    emits: ["close", "onRename"],
    setup(__props, { emit }) {
        const props = __props;
        const nameModel = ref(props.name);
        const workflowNameInput = ref(null);
        async function onRename(newName) {
            try {
                await updateWorkflow(props.id, { name: newName });
                Toast.success("Workflow renamed");
            }
            catch (e) {
                Toast.error("Failed to rename workflow");
            }
            finally {
                emit("close");
            }
        }
        return { __sfc: true, props, emit, nameModel, workflowNameInput, onRename, BForm, BFormInput, BModal, localize, Heading };
    }
});
